import { Link } from "react-router-dom"; // Use 'to' instead of 'href'


export default function Service() {
    return (
        <>
            <section className="service-1-section">
                <div className="auto-container">
                    <div className="section_heading text-center mb_90">
                        <span className="section_heading_title_small">What We Offers</span>
                        <h2 className="section_heading_title_big">Everyone Deserves Our <br /> Best Services</h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-6"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    src="assets/images/ServiceImages/basic-needs.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">In-Home Care</h4>
                                <p className="service-1-text">Receive compassionate <br /> support and assistance in the comfort and <br /> familiarity of your own home.</p>
                                <div className="service-1-link">
                                    <Link to="/service-details"><i className="icon-4"></i></Link> {/* Use 'to' instead of 'href' */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-7"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    src="assets/images/ServiceImages/assisted-living.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">Personal Care</h4>
                                <p className="service-1-text">Our dedicated team provides <br /> personalised support, <br /> treating you with empathy and utmost respect.</p>
                                <div className="service-1-link">
                                    <Link to="/service-details"><i className="icon-4"></i></Link> {/* Use 'to' instead of 'href' */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-8"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    src="assets/images/ServiceImages/wings.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">Meal Preparation</h4>
                                <p className="service-1-text">Enjoy delicious, tailored meals<br />  prepared to suit your preferences, ensuring a <br /> delightful dining experience for NDIS participants.</p>
                                <div className="service-1-link">
                                    <Link to="/service-details"><i className="icon-4"></i></Link> {/* Use 'to' instead of 'href' */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-8"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    src="assets/images/ServiceImages/broom.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">Domestic Cleaning Service</h4>
                                <p className="service-1-text">Relax in while we take<br />  care of some of your light NDIS domestic cleaning <br /> service, designed to meet your needs.</p>
                                <div className="service-1-link">
                                    <Link to="/service-details"><i className="icon-4"></i></Link> {/* Use 'to' instead of 'href' */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-8"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    src="assets/images/ServiceImages/social-services.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">Group Respite</h4>
                                <p className="service-1-text">Socialise and engage<br />  in a supportive environment during <br /> our group NDIS respite getaways.</p>
                                <div className="service-1-link">
                                    <Link to="/service-details"><i className="icon-4"></i></Link> {/* Use 'to' instead of 'href' */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-8"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    src="assets/images/ServiceImages/game.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">Monthly Board Game Nights</h4>
                                <p className="service-1-text">Join us for NDIS fun-filled<br />  gaming nights, suitable for all abilities, <br /> loads of laughs, build connections and memories.</p>
                                <div className="service-1-link">
                                    <Link to="/service-details"><i className="icon-4"></i></Link> {/* Use 'to' instead of 'href' */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-8"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    src="assets/images/ServiceImages/social-care.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">Community Care</h4>
                                <p className="service-1-text">We are here to connect, care,<br />  support the community, and foster a <br /> sense of belonging for all.</p>
                                <div className="service-1-link">
                                    <Link to="/service-details"><i className="icon-4"></i></Link> {/* Use 'to' instead of 'href' */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="service-1-block text-center wow fadeInLeft">
                                {/* <div className="service-1-icon"><i className="icon-8"></i></div> */}
                                <div className="service-1-icon">

                                <img
                                    src="assets/images/ServiceImages/home.png"
                                    alt="In-Home Respite Icon"
                                    style={{ width: "60px", height: "60px", objectFit: "contain" }}
                                    />
                                </div>
                                <h4 className="service-1-title">In-Home Respite</h4>
                                <p className="service-1-text">Take a break while we care for you at home,<br />  providing a refreshing NDIS respite for you and <br /> your loved ones.</p>
                                <div className="service-1-link">
                                    <Link to="/service-details"><i className="icon-4"></i></Link> {/* Use 'to' instead of 'href' */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
